import React from 'react'

var id = (Math.random() * 99999999999).toString(36).slice(0, 5)

export default props => <svg
  width="12"
  height="13"
  viewBox="0 0 12 13"
  fill="none"
  {...props}
>
  <path
    d="M4.08082 10.8749L4.39698 12.1593C4.51032 12.6213 4.98668 13 5.45537 13H6.30753C6.77622 13 7.25258 12.6213 7.36592 12.1593L7.68207 10.8749C7.79541 10.413 8.25729 10.1417 8.70723 10.2735L9.95735 10.6375C10.4081 10.7683 10.9697 10.5387 11.2032 10.1253L11.6293 9.37387C11.8628 8.96047 11.7801 8.35207 11.4427 8.02013L10.507 7.1006C10.1695 6.76867 10.1695 6.227 10.5079 5.89593L11.4418 4.9764C11.7793 4.64533 11.8628 4.03693 11.6293 3.62353L11.2024 2.87213C10.968 2.45873 10.4073 2.22907 9.95735 2.35993L8.70723 2.72393C8.25643 2.8548 7.79541 2.5844 7.68122 2.12247L7.36592 0.8398C7.25258 0.378733 6.77622 0 6.30753 0H5.45537C4.98668 0 4.51032 0.378733 4.39698 0.840667L4.08168 2.12333C3.96749 2.58527 3.50646 2.85653 3.05567 2.72567L1.80554 2.36167C1.35475 2.22993 0.793172 2.46047 0.559678 2.873L0.133596 3.6244C-0.0998975 4.0378 -0.0172375 4.6462 0.321072 4.97813L1.25504 5.89593C1.59165 6.22787 1.59165 6.76953 1.25504 7.10147L0.319368 8.021C-0.0172375 8.35293 -0.101602 8.96133 0.132744 9.37473L0.559678 10.1261C0.793172 10.5395 1.35475 10.7692 1.80554 10.6383L3.05567 10.2743C3.50561 10.1417 3.96749 10.413 4.08082 10.8749ZM5.88145 4.76667C6.82224 4.76667 7.58578 5.54233 7.58578 6.5C7.58578 7.4568 6.82224 8.23333 5.88145 8.23333C4.94066 8.23333 4.17712 7.4568 4.17712 6.5C4.17712 5.54233 4.94066 4.76667 5.88145 4.76667Z"
    fill={`url(#${id}-paint0_linear)`}
    fillOpacity="0.3"/>
  <defs>
    <linearGradient
      id={`${id}-paint0_linear`}
      x2="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(11.7619 13) scale(11.7619 13) rotate(180)"
    >
      <stop stopColor="#909AAA"/>
      <stop offset="1" stopColor="#7A808C"/>
    </linearGradient>
  </defs>
</svg>



// WEBPACK FOOTER //
// ./src/modules/ControlWrapper/SettingsIcon/SettingsIconSvg.js